import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import {
  normalizeSupportChatMessage,
  normalizeSupportChatConversation,
} from '@/lib/helpers/support-chat';
import type {
  RequestResponse,
  SendSupportChatMessagePayload,
  SendSupportChatMessageResponse,
  SupportChatMessage,
} from '@/types';

export const sendSupportChatMessage = async (
  payload: SendSupportChatMessagePayload
): Promise<SendSupportChatMessageResponse> => {
  const response = await axiosInstance.post<
    RequestResponse<
      | SupportChatMessage
      | Record<string, unknown>
      | SendSupportChatMessageResponse
    >
  >(endpoints.support.chatMessages, { message: payload.message });

  const data = response.data.data;

  if (data && typeof data === 'object' && 'message' in data) {
    const convId =
      (data as SendSupportChatMessageResponse).conversationId ?? 'local';
    const message =
      normalizeSupportChatMessage(
        (data as SendSupportChatMessageResponse).message
      ) ??
      ({
        id: `local-${Date.now()}`,
        content: payload.message,
        sender: 'user',
        createdAt: new Date().toISOString(),
      } satisfies SupportChatMessage);

    return { conversationId: convId, message, reply: undefined };
  }

  const message =
    normalizeSupportChatMessage(data) ??
    ({
      id: `local-${Date.now()}`,
      content: payload.message,
      sender: 'user',
      createdAt: new Date().toISOString(),
    } satisfies SupportChatMessage);

  const nestedConv = normalizeSupportChatConversation(data);

  return {
    conversationId: nestedConv?.id ?? `local-${Date.now()}`,
    message,
    reply: undefined,
  };
};
